import { all, takeLatest, put, fork, call } from 'redux-saga/effects';
import actions from './actions';
import * as writeEssayServices from '@iso/services/writing/writeEssay';
import swal from 'sweetalert';
//#region CRUD
export function* getWriteEssay() {
	yield takeLatest(actions.GET_WRITE_ESSAY, function* ({ payload }) {
		const { model } = payload;
		try {
			var response = yield call(writeEssayServices.getWriteEssay, model);
			if (response.data.success === true) {
				var data = response.data.data.data;
				var totalItems = response.data.data.total;
				yield put({
					type: actions.GET_WRITE_ESSAY_SUCCESS,
					payload: { data, totalItems },
				});
			}
		} catch (e) {
			yield put({
				type: actions.WRITING_LOADING_FALSE,
			});
		}
	});
}

export function* getWriteEssayDetail() {
	yield takeLatest(actions.GET_WRITE_ESSAY_DETAIL, function* ({ payload }) {
		const { id } = payload;
		try {
			var response = yield call(writeEssayServices.getWriteEssayDetail, id);
			if (response.data.success === true) {
				var data = response.data.data;
				yield put({
					type: actions.GET_WRITE_ESSAY_DETAIL_SUCCESS,
					payload: { data },
				});
			}
		} catch (e) {
			yield put({
				type: actions.WRITING_LOADING_FALSE,
			});
		}
	});
}

export function* createQuesWriteEssay() {
	yield takeLatest(actions.CREATE_NEW_QUESTION_WRITE_ESSAY, function* ({ payload, cbSuccess, cbError }) {
		const { body } = payload;
		try {
			var response = yield call(writeEssayServices.createQuesWriteEssay, body);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
			if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			}
		}
	});
}

export function* updateWriteEssayDetail() {
	yield takeLatest(actions.UPDATE_WRITE_ESSAY_DETAIL, function* ({ payload, cbSuccess, cbError }) {
		const { model } = payload;
		try {
			var response = yield call(writeEssayServices.updateWriteEssayDetail, model);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export function* deleteWriteEssay() {
	yield takeLatest(actions.DELETE_WRITE_ESSAY, function* ({ payload, cbSuccess, cbError }) {
		const { id } = payload;
		try {
			var response = yield call(writeEssayServices.deleteWriteEssay, id);
			if (response.data.success === true) {
				yield cbSuccess();
			}
		} catch (e) {
			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
			else yield cbError();
		}
	});
}

export default function* rootSaga() {
	yield all([
		fork(getWriteEssay),
		fork(getWriteEssayDetail),
		fork(createQuesWriteEssay),
		fork(updateWriteEssayDetail),
		fork(deleteWriteEssay),
	]);
}
